import { TRPCClientError } from "@trpc/client";

function unauthorizedAuthSource(error: unknown): string | null {
  if (!(error instanceof TRPCClientError)) return null;
  const data = error.data as unknown;
  if (!data || typeof data !== "object") return null;
  const record = data as Record<string, unknown>;
  if (record.code !== "UNAUTHORIZED") return null;
  return typeof record.authSource === "string" ? record.authSource : "backend";
}

export function isUnauthorizedTRPCError(error: unknown): boolean {
  return unauthorizedAuthSource(error) !== null;
}

// True only for a real backend token rejection, not a transient server-side session-gate miss.
export function isBackendUnauthorizedError(error: unknown): boolean {
  return unauthorizedAuthSource(error) === "backend";
}

export function getSessionBackendAccessToken(
  session:
    | {
        user?: { access_token?: string };
        access_token?: string;
      }
    | null
    | undefined,
): string | undefined {
  const token = session?.user?.access_token ?? session?.access_token;
  return typeof token === "string" && token.length > 0 ? token : undefined;
}
